function classesToString(names) {
    return names.filter(Boolean).join(' ');
}
function chunkArray(myArray, chunkSize) {
    const results = [];
    while (myArray.length) {
        results.push(myArray.splice(0, chunkSize));
    }
    return results;
}

export { chunkArray as a, classesToString as c };

//# sourceMappingURL=utils-17533423.js.map